import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { updateDynamicMetadata } from '@adornis/baseql/client/introspection.js';
import { QueryCache } from '@adornis/baseql/client/requestHandlers/queryCache.js';
import { updateDynamicValidators } from '@adornis/cms/db/dynamic-validators.js';
import { ChancenDynamicClassFormOfFinanzing } from '@chancenwerk/shared/_cms/financing/entities/ChancenDynamicClassFormOfFinanzing.js';
import { ChancenDynamicClassProduct } from '@chancenwerk/shared/_cms/products/entities/ChancenDynamicClassProduct.js';
import '@chancenwerk/client/design/index.js';
import '@chancenwerk/client/translation-data.js';
import { provideGlobalContext } from '@adornis/functional-lit/directive-provide-context.js';
import { translationContext } from '@adornis/internationalization/client/translation-context.js';
import { m } from '@chancenwerk/translation-data/localisation/out/messages.js';

// ====================== Import DB to fill metadata-tree
import '@chancenwerk/shared/index.js';
// ====================== Import main-element.ts as 'frontend-entry'
import { TerminateReason } from '@adornis/baseql/protocol.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { checkNetzRedirect } from '@chancenwerk/client/netz-redirector.js';
import './main-element.js';
// ====================== Styling

// TODO these imports should be in the desgin package, but the cli does not support this at the moment.
import '@adornis/fonts/fontSrc/montserrat.js';
import 'https://fonts.googleapis.com/css2?family=ABeeZee&display=swap';
import 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&display=swap';
import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20,400,0..1,0';
import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20,700,0..1,0';
import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20,400,0..1,0';
import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20,700,0..1,0';
import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL,GRAD@20,400,0..1,0';
import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL,GRAD@20,700,0..1,0';

const transportHandler = BaseQLClient.createTransportHandler({
  onConnect: reason => {
    if (!reason || reason === TerminateReason.SCHEMA_REBUILD) {
      void updateDynamicMetadata().then(() => {
        void updateDynamicValidators([ChancenDynamicClassProduct._class, ChancenDynamicClassFormOfFinanzing._class]);
      });
    }
  },
});
const queryCache = new QueryCache(transportHandler);
BaseQLClient.initHandler(queryCache);

void subscribeCurrentUser(() => ({
  ...AdornisUser.allFields,
  _class: 1,
  vorname: 1,
  nachname: 1,
  lastCampusLogin: 1,
  lastActivity: 1,
}));

checkNetzRedirect().catch(console.error);

//
// Init App
//

import { initApp } from '@adornis/functional-lit/init-app.js';
import { webcomponent } from '@adornis/functional-lit/webcomponent.js';
import { html } from 'lit';

const root = document.getElementById('root');
if (root) {
  root.style.backgroundColor = 'rgb(242, 242, 242)';
}

provideGlobalContext(translationContext, m);

initApp(
  webcomponent('root-element', () => html`<main-element></main-element>`, {
    shadowRoot: true,
    styles: {
      ':host': {
        overflow: 'auto',
      },
    },
  }),
);
